import { FocusEventHandler } from "react";

export const scrollIntoView: FocusEventHandler<HTMLInputElement> = (e) => {
  e.target.scrollIntoView({
    behavior: "smooth",
    block: "center",
  });
};
